module.exports = __webpack_public_path__ + "images/default_avatars/dingtalk@2x-09619cd11583fa97889e3681df368491.png";